"use client";

import useGetDownloadLink    from "_common/hooks/useGetDownloadLink";
import { SNG_DOWNLOAD_LINK } from "_config/index";

function X2410MWebDownloadPage4 ( props ) {
	const {
		subtraction1341,
		downloadApp1
	} = props;

	const downloadLink  = useGetDownloadLink ();
	const downloadAppFn = () => {
		window.open ( downloadLink, "_blank" );
	};

	return (
		<div className = "overlap-group-27">
			<button className = "download-app-btn"
				onClick          = { downloadAppFn }
			>
				<div className = "group-9287-6">
					<div className = "group-9-6">
						<div className = "group-9-6">
							<img className = "subtraction-134-6"
								src           = { subtraction1341 }
							/>
						</div>
					</div>
				</div>

				<div className = "download-app-11 montserrat-bold-white-16px">
					{downloadApp1}
				</div>
			</button>
		</div>
	);
}

export default X2410MWebDownloadPage4;
